import { useEffect, useState } from "react";
import AdminLayout from "@/pages/admin/AdminLayout";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Droplet, ExternalLink } from "lucide-react";

const AdminProducts = () => {
  const [products, setProducts] = useState([]);
  const [moqStandard, setMoqStandard] = useState("");

  useEffect(() => {
    api.get("/admin/products/all").catch(() => api.get("/products/all"))
      .then((r) => {
        setProducts(r.data.products || []);
        setMoqStandard(r.data.moq_standard || "");
      })
      .catch(() => {});
  }, []);

  return (
    <AdminLayout>
      <div className="flex justify-between items-start mb-8 flex-wrap gap-4">
        <div>
          <div className="ft-eyebrow mb-2">Products</div>
          <h1 className="text-3xl font-bold tracking-tight text-[var(--ft-black)]">Product Manager</h1>
          <p className="text-[var(--ft-muted)] mt-2 max-w-2xl">
            Overview of the V1.0 water product catalog. Available bottle sizes for each product
            are resolved dynamically from the <span className="font-semibold">Bottle Sizes</span> catalog.
          </p>
          <div className="mt-3 text-xs text-[var(--ft-muted)]">
            <span className="font-semibold text-[var(--ft-charcoal)]">Standard:</span>{" "}
            <span className="font-mono">{moqStandard}</span>
          </div>
        </div>
        <Link to="/admin/bottle-sizes" className="ft-btn-ghost inline-flex items-center gap-2" data-testid="manage-sizes-link">
          <Droplet size={14} /> Manage Bottle Sizes <ExternalLink size={12} />
        </Link>
      </div>

      <div className="grid md:grid-cols-2 gap-5" data-testid="admin-products-grid">
        {products.map((p) => (
          <div key={p.slug} className="ft-card" data-testid={`admin-product-${p.slug}`}>
            <div className="flex items-start justify-between gap-3 flex-wrap mb-3">
              <div>
                <div className="font-semibold text-[var(--ft-black)] text-lg">{p.name}</div>
                <div className="text-xs font-mono text-[var(--ft-muted)] mt-0.5">{p.slug}</div>
              </div>
              <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[0.625rem] font-bold tracking-[0.18em] uppercase ${
                p.status === "active"
                  ? "bg-[var(--ft-gold)] text-[var(--ft-black)]"
                  : "bg-[var(--ft-charcoal)] text-white/80"
              }`}>
                {p.status}
              </span>
            </div>
            <p className="text-sm text-[var(--ft-muted)] mb-4">{p.tagline}</p>
            <div className="mb-3">
              <div className="text-[0.6875rem] uppercase tracking-[0.24em] text-[var(--ft-gold)] font-semibold mb-2">
                Available Sizes
              </div>
              <div className="flex flex-wrap gap-2">
                {(p.bottle_options || []).length === 0 && (
                  <span className="text-xs italic text-[var(--ft-muted)]">No sizes configured — visit Bottle Sizes.</span>
                )}
                {(p.bottle_options || []).map((b) => (
                  <span key={b} className="text-xs px-3 py-1 rounded-full border border-[var(--ft-border)] font-medium">{b}</span>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3 text-xs text-[var(--ft-muted)] pt-3 border-t border-[var(--ft-border)]">
              <div>
                <div className="uppercase tracking-widest">Timeline</div>
                <div className="text-[var(--ft-black)] font-semibold text-sm mt-0.5">{p.timeline}</div>
              </div>
              <div>
                <div className="uppercase tracking-widest">MOQ</div>
                <div className="text-[var(--ft-black)] font-semibold text-[0.7rem] mt-0.5 leading-tight">{p.min_order}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
};

export default AdminProducts;
